import { render, staticRenderFns } from "./CustomizeMetricSetModal.vue?vue&type=template&id=62b35352&scoped=true&"
import script from "./CustomizeMetricSetModal.vue?vue&type=script&lang=js&"
export * from "./CustomizeMetricSetModal.vue?vue&type=script&lang=js&"
import style0 from "./CustomizeMetricSetModal.vue?vue&type=style&index=0&id=62b35352&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b35352",
  null
  
)

export default component.exports